/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReassignUser } from '../../models/reassign-user';

export interface ApiTicketItemIdReassignCommunicationsPut$Params {
  item_id: number;
      body: ReassignUser
}

export function apiTicketItemIdReassignCommunicationsPut(http: HttpClient, rootUrl: string, params: ApiTicketItemIdReassignCommunicationsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiTicketItemIdReassignCommunicationsPut.PATH, 'put');
  if (params) {
    rb.path('item_id', params.item_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiTicketItemIdReassignCommunicationsPut.PATH = '/api/ticket/{item_id}/reassign-communications';
